import { Box } from '@mantine/core';

interface Props {
  color: string;
  size?: number;
}

export const LineChartLegendMarker = ({ color, size = 16 }: Props) => {
  const viewBoxSize = 16;
  const halfSize = viewBoxSize / 2;
  const innerCircleRadius = viewBoxSize * 0.25;
  const dotRadius = innerCircleRadius * 0.75;

  return (
    <Box
      style={{
        width: size,
        height: size,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <svg width={size} height={size} viewBox={`0 0 ${viewBoxSize} ${viewBoxSize}`} xmlns="http://www.w3.org/2000/svg">
        {/* Background circle */}
        <circle cx={halfSize} cy={halfSize} r={halfSize} fill={`${color}20`} />

        {/* Horizontal line */}
        <line x1="0" y1={halfSize} x2={viewBoxSize} y2={halfSize} stroke={color} strokeWidth="1.5" />

        {/* White circle */}
        <circle cx={halfSize} cy={halfSize} r={innerCircleRadius} fill="white" />

        {/* Colored center dot */}
        <circle cx={halfSize} cy={halfSize} r={dotRadius} fill={color} />
      </svg>
    </Box>
  );
};
